import { useState, useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { EnvelopeFill, Whatsapp, Linkedin, GeoAltFill } from 'react-bootstrap-icons';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import animatedContact from '../assets/img/animatedContact.gif'

function Contact() {
    const { t } = useTranslation();
    const formInitalDetails = {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
    }
    const [formDetails, setFormDetails] = useState(formInitalDetails);
    const [buttonText, setButtonText] = useState(t('contact.send'));
    const [status, setStatus] = useState({});

    const [showBooking, setShowBooking] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [availableSlots, setAvailableSlots] = useState([]);
    const [bookingLoading, setBookingLoading] = useState(false);
    const [bookingStatus, setBookingStatus] = useState(null);

    useEffect(() => {
        if (!selectedDate) return;
        setSelectedSlot(null);
        setAvailableSlots([]);
        const ds = selectedDate.toISOString().split('T')[0];
        const isProd = window.location.hostname !== 'localhost';
        const API_BASE = isProd ? '' : (process.env.REACT_APP_URL ? new URL(process.env.REACT_APP_URL).origin : '');
        setBookingLoading(true);
        fetch(`${API_BASE}/api/booking?date=${ds}`)
            .then(r => r.json())
            .then(data => {
                setAvailableSlots(data.available || []);
                setBookingLoading(false);
            })
            .catch(() => setBookingLoading(false));
    }, [selectedDate]);

    const onFormUpdate = (category, value) => {
        setFormDetails({
            ...formDetails,
            [category]: value
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setButtonText(t('contact.sending'));
        setBookingStatus(null);
        const isProd = window.location.hostname !== 'localhost';
        const contactUrl = isProd ? '/api/server' : (process.env.REACT_APP_URL || '/api/server');
        let response = await fetch(contactUrl, {
            method: "POST",
            headers: {
                "Content-Type": "Application/json;charset=utf-8",
                "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify(formDetails),
        }).then(r => r.status).catch(() => 500);

        let bookingOk = true;
        if (showBooking && selectedSlot && selectedDate) {
            const ds = selectedDate.toISOString().split('T')[0];
            const API_BASE = isProd ? '' : (process.env.REACT_APP_URL ? new URL(process.env.REACT_APP_URL).origin : '');
            const bookingResp = await fetch(`${API_BASE}/api/booking`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    date: ds,
                    time: selectedSlot,
                    name: formDetails.firstName + ' ' + formDetails.lastName,
                    email: formDetails.email,
                    phone: formDetails.phone,
                    message: formDetails.message
                })
            }).catch(() => ({ ok: false }));
            bookingOk = bookingResp.ok;
        }

        setButtonText(t('contact.send'));
        if (response === 200 && bookingOk) {
            setStatus({ success: true, message: bookingOk && showBooking ? t('contact.bookingSuccess') : t('contact.success') });
            setFormDetails(formInitalDetails);
            setShowBooking(false);
            setSelectedDate(null);
            setSelectedSlot(null);
            setAvailableSlots([]);
        } else if (response === 200 && !bookingOk) {
            setStatus({ success: true, message: t('contact.success') });
            setFormDetails(formInitalDetails);
            setBookingStatus({ error: true, message: t('contact.bookingError') });
        } else {
            setStatus({ success: false, message: t('contact.error') });
        }
    };

    const tileDisabled = ({ date }) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return date < today || date.getDay() === 0 || date.getDay() === 6;
    };

    return (
        <section className="contact" id="connect">
            <Container>
                <div className="contact-bx">
                    <Row className="align-items-center mb-4">
                        <Col md={5}>
                            <img className="contactPic" src={animatedContact} alt="Contact Me" loading="lazy" width="300" />
                        </Col>
                        <Col md={7}>
                            <h2>{t('contact.title')}</h2><br />
                            <form onSubmit={handleSubmit}>
                                <Row>
                                    <Col sm={6} className="px-1">
                                        <input className="form-control mb-2" type="text" value={formDetails.firstName} placeholder={t('contact.firstName')} onChange={(e) => onFormUpdate('firstName', e.target.value)} />
                                    </Col>
                                    <Col sm={6} className="px-1">
                                        <input className="form-control mb-2" type="text" value={formDetails.lastName} placeholder={t('contact.lastName')} onChange={(e) => onFormUpdate('lastName', e.target.value)} />
                                    </Col>
                                    <Col sm={6} className="px-1">
                                        <input className="form-control mb-2" type="email" value={formDetails.email} placeholder={t('contact.email')} onChange={(e) => onFormUpdate('email', e.target.value)} />
                                    </Col>
                                    <Col sm={6} className="px-1">
                                        <input className="form-control mb-2" type="tel" value={formDetails.phone} placeholder={t('contact.phone')} onChange={(e) => onFormUpdate('phone', e.target.value)} />
                                    </Col>
                                    <Col>
                                        <textarea className="form-control mb-2" rows="6" value={formDetails.message} placeholder={t('contact.message')} onChange={(e) => onFormUpdate('message', e.target.value)}></textarea>

                                        <label className="booking-checkbox-label">
                                            <input type="checkbox" checked={showBooking} onChange={(e) => { setShowBooking(e.target.checked); if (!e.target.checked) { setSelectedDate(null); setSelectedSlot(null); } }} />
                                            <span>{t('contact.bookingCheckbox')}</span>
                                        </label>

                                        {showBooking && (
                                            <div className="booking-panel">
                                                <div className="booking-calendar-wrap">
                                                    <Calendar onChange={setSelectedDate} value={selectedDate} tileDisabled={tileDisabled} minDetail="month" />
                                                </div>
                                                {selectedDate && (
                                                    <div className="booking-slots-wrap">
                                                        {bookingLoading ? (
                                                            <p className="booking-status-text">{t('contact.bookingLoading')}</p>
                                                        ) : availableSlots.length === 0 ? (
                                                            <p className="booking-status-text">{t('contact.bookingNoSlots')}</p>
                                                        ) : (
                                                            <div className="booking-slots-grid">
                                                                {availableSlots.map(s => (
                                                                    <button key={s} type="button" className={`booking-slot-btn ${selectedSlot === s ? 'selected' : ''}`} onClick={() => setSelectedSlot(s)}>
                                                                        {s}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        )}
                                                        {selectedSlot && (
                                                            <p className="booking-slot-confirm">{t('contact.bookingSlotSelected')} <strong>{selectedSlot}</strong></p>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {bookingStatus && (
                                            <p className="danger">{bookingStatus.message}</p>
                                        )}

                                        <button className="btn btn-info" type="submit"><span>{buttonText}</span></button>
                                    </Col>
                                    {status.message &&
                                        <p className={status.success === false ? "danger" : "success"}>{status.message}</p>
                                    }
                                </Row>
                            </form>
                        </Col>
                    </Row>

                    <div className="contact-info-email-row">
                        <div className="contact-info-item contact-info-item-email">
                            <EnvelopeFill className="contact-info-icon" />
                            <div>
                                <span className="contact-info-label">{t('contact.infoEmail')}</span>
                                <a href="mailto:coronafacundo@gmail.com" className="contact-info-value">coronafacundo@gmail.com</a>
                            </div>
                        </div>
                    </div>

                    <div className="contact-info-list contact-info-horizontal">
                        <div className="contact-info-item">
                            <Whatsapp className="contact-info-icon whatsapp-icon" />
                            <div>
                                <span className="contact-info-label">{t('contact.infoWhatsapp')}</span>
                                <a
                                    href="https://api.whatsapp.com/send?phone=+543515932204&text=Hola, vi tu portfolio y me gustaría contactarte."
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="contact-info-value"
                                >
                                    +54 351 593-2204
                                </a>
                            </div>
                        </div>
                        <div className="contact-info-item">
                            <Linkedin className="contact-info-icon linkedin-icon" />
                            <div>
                                <span className="contact-info-label">LinkedIn</span>
                                <a
                                    href="https://www.linkedin.com/in/facucorona/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="contact-info-value"
                                >
                                    /in/facucorona
                                </a>
                            </div>
                        </div>
                        <div className="contact-info-item">
                            <GeoAltFill className="contact-info-icon location-icon" />
                            <div>
                                <span className="contact-info-label">{t('contact.infoLocation')}</span>
                                <span className="contact-info-value">Córdoba, Argentina 🇦🇷</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    )
}

export default Contact
